import { render, staticRenderFns } from "./DictionaryAcceptances.vue?vue&type=template&id=350f740f&scoped=true&"
import script from "./DictionaryAcceptances.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f740f",
  null
  
)

export default component.exports